import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import IconPhone from '@material-ui/icons/Phone';
import IconEmail from '@material-ui/icons/Email';

import IconFacebook from '@material-ui/icons/Facebook';
import IconTwitter from '@material-ui/icons/Twitter';
import IconYouTube from '@material-ui/icons/YouTube';
import IconInstagram from '@material-ui/icons/Instagram';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import PersonIcon from '@material-ui/icons/Person';
//import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { useAppDrawerSlice } from '../AppDrawer/slice';
import { selectAppDrawerVisibility } from '../AppDrawer/slice/selectors';

import { config } from '../../../config';

import UserContext from '../../../contexts/user/User';
import { Link } from 'react-router-dom';
import { appConfig } from 'config/app';
import { Hidden } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  hambButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    position: 'relative',
    top: 7,
    left: 12,
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.contrastText,
    },
    padding: '0 12px 10px 0',
  },
  topBar: {
    background: theme.palette.primary.dark,
    fontSize: '13px',
    borderTop: '4px solid transparent',
    borderBottom: '1px solid #ebebeb',
    color: '#ffffff',
    [theme.breakpoints.between('xs', 'xs')]: {
      height: 50,
    },
    [theme.breakpoints.between('sm', 'sm')]: {
      height: 56,
    },
    [theme.breakpoints.between('md', 'md')]: {
      height: 56,
    },
  },
  wrapper: {
    width: 'calc(100% - 150px)',
    padding: '0 0 0 0px',
    overflow: 'visible',
    display: 'inline-table',
    zIndex: 1000,
    margin: '0 auto',
    position: 'relative',
    right: 0,
    textAlign: 'right',
  },
  topPhone: {
    borderRight: '1px solid #ebebeb',
    paddingRight: '20px',
    paddingLeft: '20px',
    padding: '1px 20px 9px 20px',
    width: 'auto',
    position: 'relative',
    display: 'inline-block',
    top: 0,
    right: 0,
    margin: '10px 0 0px 0',
    '& svg': {
      color: '#ffffff',
      textDecoration: 'none',
    },
  },
  topEmail: {
    borderRight: '1px solid #ebebeb',
    paddingRight: '20px',
    paddingLeft: '20px',
    padding: '11px 20px 9px 20px',
    width: 'auto',
    position: 'relative',
    display: 'inline-block',
    top: 0,
    margin: '0px 0 0px 0px',
    '& a': {
      color: '#ffffff',
      textDecoration: 'none',
    },
    '& svg': {
      color: '#ffffff',
      textDecoration: 'none',
    },
  },
  headerSocial: {
    padding: '0px 0px 0 10px',
    textAlign: 'center',
    marginTop: '0px',
    display: 'inline-block',
    '& div': {
      display: 'inline-block',
      marginRight: 5,
    },
    '& a': {
      textDecoration: 'none',
      '& svg': {
        backgroundColor: '#ffffff',
        borderRadius: 5,
        padding: 3,
        textDecoration: 'none',
        [theme.breakpoints.between('xs', 'md')]: {
          height: 28,
        },
        [theme.breakpoints.up('md')]: {
          height: 28,
        },
      },
    },
  },
  appBar: {
    width: `100%`,
    marginLeft: 0,
    zIndex: theme.zIndex.drawer + 1,
    background: theme.palette.background.default,
    [theme.breakpoints.between('xs', 'xs')]: {
      height: '110px',
    },
    [theme.breakpoints.between('sm', 'sm')]: {
      height: '150px',
    },
    [theme.breakpoints.between('md', 'md')]: {
      height: '150px',
    },
    [theme.breakpoints.between('lg', 'lg')]: {
      height: '150px',
    },
    [theme.breakpoints.between('xl', 'xl')]: {
      height: '130px',
    },
  },
  menu: {
    position: 'absolute',
    right: '150px',
    [theme.breakpoints.between('xs', 'md')]: {
      right: '50px',
    },
  },
  menuLink: {
    color: theme.palette.primary.dark,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.contrastText,
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.contrastText,
    },
  },
  title: {
    flexGrow: 1,
    textAlign: 'center',
  },
  logo: {
    [theme.breakpoints.between('xs', 'xs')]: {
      height: '50px',
      width: 'auto',
      margin: '0 0 0 0px',
      padding: 0,
    },
    [theme.breakpoints.between('sm', 'sm')]: {
      height: '60px',
      width: 'auto',
      margin: '0 0 0 10px',
      padding: 0,
    },
    [theme.breakpoints.between('md', 'md')]: {
      height: '90px',
      width: 'auto',
      margin: '0 0 0 140px',
      padding: theme.spacing(1),
    },
    [theme.breakpoints.between('lg', 'lg')]: {
      height: '110',
      width: 'auto',
      margin: '0 0 0 200px',
      padding: theme.spacing(1),
    },
    [theme.breakpoints.between('xl', 'xl')]: {
      height: '100px',
      width: 'auto',
      margin: '0 0 0 200px',
      padding: theme.spacing(1),
    },
  },
  icon: {
    width: 'auto',
    height: '16px',
  },
  socialIcon: {
    width: 'auto',
    height: '18px',
  },
  userIcon: {
    color: theme.palette.primary.dark + ' !important',
  },
}));

export function FSJPAppTopBar(props) {
  const { signOut /*, currentUser*/ } = React.useContext(UserContext);

  const { actions } = useAppDrawerSlice();

  const dispatch = useDispatch();
  const appDrawerVisibility = useSelector(selectAppDrawerVisibility);
  const navigate = useNavigate();

  const classes = useStyles();
  //const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileEdit = () => {
    setAnchorEl(null);
    dispatch(actions.changeVisibility(false));
    //    navigate(
    navigate(
      config.react_routes.prefix +
        config.react_routes.modules.user.prefix +
        config.react_routes.modules.user.services.profileUpdate,
    );
  };

  const handleSignIn = () => {
    setAnchorEl(null);
    dispatch(actions.changeVisibility(false));
    //    navigate(
    navigate(
      config.react_routes.prefix +
        config.react_routes.modules.user.prefix +
        config.react_routes.modules.user.services.signin,
    );
  };

  const handlePasswordResetRequest = () => {
    setAnchorEl(null);
    dispatch(actions.changeVisibility(false));
    //    navigate(
    navigate(
      config.react_routes.prefix +
        config.react_routes.modules.user.prefix +
        config.react_routes.modules.user.services.passwordResetRequest,
    );
  };

  const handleChangePassword = () => {
    setAnchorEl(null);
    dispatch(actions.changeVisibility(false));
    //    navigate(
    navigate(
      config.react_routes.prefix +
        config.react_routes.modules.user.prefix +
        config.react_routes.modules.user.services.changePassword,
    );
  };

  const onSignOut = async e => {
    setAnchorEl(null);
    e.preventDefault();
    localStorage.removeItem(config.localUserDTO);
    await signOut().then(resp => {
      dispatch(actions.changeVisibility(false));
      dispatch(actions.changeUserInSession(false));
      dispatch(actions.changeUserName(''));
      //    navigate(
      navigate(config.react_routes.prefix);
    });
  };

  useEffect(() => {
    /*currentUser()
      .then(resp => {
        if (resp.respCode === 0) {
          setUserInSession(true);
          if (_userDTO) {
            let userDTO = JSON.parse(_userDTO);
            if (userDTO.role) {
              const m = menus.filter(m => {
                return m.name === userDTO.role.name;
              });
              setMenu(m[0]);
              setUserName(userDTO.firstName);
            }
          }
        } else {
          setUserInSession(false);
          const url =
            config.appURL +
            config.react_routes.prefix +
            config.react_routes.modules.user.prefix +
            config.react_routes.modules.user.services.signin;
          if (
            document.location.href !== url &&
            document.location.href !==
              config.react_routes.modules.user.services.passwordReset
          ) {
            navigate(url);
          }
        }
      })
      .catch(resp => {
        setUserInSession(false);
        /*const url =
          config.appURL +
          config.react_routes.prefix +
          config.react_routes.modules.user.prefix +
          config.react_routes.modules.user.services.signin;
        if (document.location.href !== url) {
          navigate(url);
        }*/
    //});
  }, []);

  return (
    <AppBar position="sticky" className={classes.appBar}>
      <div className={classes.topBar}>
        {appDrawerVisibility.userInSession ? (
          <IconButton
            edge="start"
            className={classes.hambButton}
            color="secondary"
            aria-label="menu"
            onClick={() => {
              dispatch(
                actions.changeVisibility(!appDrawerVisibility.visibility),
              );
            }}
          >
            <MenuIcon />
          </IconButton>
        ) : null}
        <div className={classes.wrapper}>
          <Hidden xsDown>
            <div className={classes.topPhone}>
              <IconPhone className={classes.icon} />
              &nbsp;&nbsp; +57 (601) 245 4224
            </div>
            <div className={classes.topEmail}>
              <IconEmail className={classes.icon} />
              &nbsp;&nbsp;
              <a href="mailto:fundacion@serviciojuridicopopular.org">
                fundacion@serviciojuridicopopular.org
              </a>
            </div>
            <div className={classes.headerSocial}>
              <div id="facebook">
                <a
                  href="https://www.facebook.com/SerJurPop"
                  target="_blank"
                  rel="noreferrer"
                >
                  <IconFacebook
                    className={classes.socialIcon}
                    style={{ color: '#2D65B1' }}
                  />
                </a>
              </div>
              <div id="twitter">
                <a
                  href="https://twitter.com/SerJurPop"
                  target="_blank"
                  rel="noreferrer"
                >
                  <IconTwitter
                    className={classes.socialIcon}
                    style={{ color: '#1C96E8' }}
                  />
                </a>
              </div>
              <div id="instagram">
                <a
                  href="https://www.instagram.com/SerJurPop"
                  target="_blank"
                  rel="noreferrer"
                >
                  <IconInstagram
                    className={classes.socialIcon}
                    style={{ color: '#1C96E8' }}
                  />
                </a>
              </div>
              <div id="youtube">
                <a
                  href="https://www.youtube.com/@SerJurPop"
                  target="_blank"
                  rel="noreferrer"
                >
                  <IconYouTube
                    className={classes.socialIcon}
                    style={{ color: '#ff0000' }}
                  />
                </a>
              </div>
            </div>
          </Hidden>
        </div>
      </div>
      <Toolbar>
        <img
          src="/media/fsjp/logo-fsjp.png"
          alt="Logo Fundación Servicio Jurídico Popular"
          className={classes.logo}
          style={{ height: 90 }}
        />

        <div className={classes.menu}>
          <Hidden xsDown>
            <a
              href={'https://serviciojuridicopopular.org/'}
              className={classes.menuLink}
            >
              <span>Inicio</span>
            </a>

            <div
              style={{
                display: appDrawerVisibility.userInSession
                  ? 'inline-block'
                  : 'none',
              }}
            >
              <Button
                className={classes.menuButton}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <PersonIcon className={classes.userIcon} />
              </Button>

              {appDrawerVisibility.userInSession ? (
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem style={{ textAlign: 'center' }}>
                    &nbsp;&nbsp;{appDrawerVisibility.userName}
                  </MenuItem>
                  <MenuItem onClick={handleProfileEdit}>Mi Cuenta</MenuItem>
                  <MenuItem onClick={handleChangePassword}>
                    Cambiar Clave
                  </MenuItem>
                  <MenuItem onClick={onSignOut}>Salir</MenuItem>
                </Menu>
              ) : (
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handlePasswordResetRequest}>
                    Recuperar Clave
                  </MenuItem>
                  <MenuItem onClick={handleSignIn}>Ingresar</MenuItem>
                </Menu>
              )}
            </div>
          </Hidden>
          <Hidden smUp>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
              style={{ color: '#000000 !important', right: '0 !important' }}
            >
              <IconButton
                edge="start"
                color="primary"
                aria-label="menu"
                style={{ color: '#000000 !important' }}
              >
                <PersonIcon style={{ color: '#000000 !important' }} />
              </IconButton>
            </Button>
            {!appDrawerVisibility.userInSession ? (
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem>
                  <Link
                    to={
                      appConfig.react_routes.prefix +
                      appConfig.react_routes.modules.conciliation.prefix +
                      appConfig.react_routes.modules.conciliation.services
                        .viabilityQuery
                    }
                    className={classes.menuLink}
                    style={{ textDecoration: 'none' }}
                  >
                    <span>Solicitud de Audiencia</span>
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link
                    to={
                      config.react_routes.prefix +
                      config.react_routes.modules.user.prefix +
                      config.react_routes.modules.user.services.signin
                    }
                    className={classes.menuLink}
                    style={{ textDecoration: 'none' }}
                  >
                    <span>Iniciar Sesión</span>
                  </Link>
                </MenuItem>
              </Menu>
            ) : (
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem style={{ textAlign: 'center' }}>
                  &nbsp;&nbsp;{appDrawerVisibility.userName}
                </MenuItem>
                <MenuItem onClick={handleProfileEdit}>Mi Cuenta</MenuItem>
                <MenuItem onClick={handleChangePassword}>
                  Cambiar Clave
                </MenuItem>
                <MenuItem onClick={onSignOut}>Salir</MenuItem>
              </Menu>
            )}
          </Hidden>
        </div>
      </Toolbar>
    </AppBar>
  );
}
